/**
 * The track an export lineage source was on (1.8.0 fix): the lineage keeps only 'video', 'layer' or 'audio' and the
 * clip's id, so the video track's V number and the audio track's A number come from the sequence when the clip is
 * still in it. Before 1.8.0 every video track and every audio track read "A2".
 */
import { allAudioTracks, type SequenceDocument } from '@prism/contracts';

export function lineageTrackLabel(s: { track: 'video' | 'audio' | 'layer'; clipId: string }, doc?: SequenceDocument | null): string {
  if (s.track === 'video') return 'V1';
  if (s.track === 'layer') {
    const i = (doc?.layers ?? []).findIndex((l) => l.clips.some((c) => c.id === s.clipId));
    return i >= 0 ? `V${i + 2}` : 'Video track';
  }
  const t = doc ? allAudioTracks(doc).find((a) => a.clips.some((c) => c.id === s.clipId)) : undefined;
  return t ? `A${t.number}` : 'Audio track';
}
